import React, { useState } from "react";
import { motion } from "framer-motion";
import FadeInSectionDownToUp from "../../Components/FadeAnimations/FadeInSectionDownToUp";
import ContactNumberField from "../../Components/Contact/ContactNumberField";
import LocationSelector from "../../Components/Contact/LocationSelector";
import { getPhoneMaxLength, validateMobileNumber } from "../../Components/Contact/PhoneValidation";
import { VelsUniversityCourses, VelsUniversityPGCourses } from "../../Components/Contact/Qualification";
import axios from "axios";
import { useNavigate } from "react-router-dom";

export default function HeroSection() {

    const navigate = useNavigate();

    const [name, setName] = useState("");
    const [countryCode, setCountryCode] = useState("");
    const [number, setNumber] = useState("");
    const [mail, setMail] = useState("");
    const [qualification, setQualification] = useState("");
    const [state, setState] = useState("");
    const [district, setDistrict] = useState("");
    const [lookingfor, setLookingfor] = useState("");
    const [programType, setProgramType] = useState("");
    const [message, setMessage] = useState("");
    const [hearAbout, setHearAbout] = useState("");
    const [hearOther, setHearOther] = useState("");
    const [consent, setConsent] = useState(false);

    // Validation helpers
    const onlyLetters = /^[A-Za-z\s]+$/;
    const onlyNumbers = /^[0-9]+$/;
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    // Toast state
    const [toast, setToast] = useState({
        show: false,
        message: "",
        type: "",
    });

    const showToast = (message, type = "error") => {
        setToast({
            show: true,
            message,
            type,
        });

        setTimeout(() => {
            setToast({
                show: false,
                message: "",
                type: "",
            });
        }, 3000);
    };

    // Get current page URL
    const currentPage = window.location.href;
    // Determine source based on URL
    const sourcePage =
        currentPage.startsWith("https://mhcockpit.com/contact")
            ? "Vels Landing Page Lead"
            : currentPage;

    const addData = async () => {
        const requiresLocation = countryCode === "+91";
        const required = [
            name,
            mail,
            countryCode,
            number,
            qualification,
            lookingfor,
            hearAbout,
        ];

        if (requiresLocation) {
            required.push(state, district);
        }

        if (required.some((v) => v === "")) {
            showToast("Please fill in all required fields.");
            return;
        }

        if (!onlyLetters.test(name)) {
            showToast("Name should contain only letters.");
            return;
        }

        if (name.length > 50) {
            showToast("Name should not exceed 50 characters.");
            return;
        }

        if (!emailRegex.test(mail)) {
            showToast("Please enter a valid email.");
            return;
        }

        if (!onlyNumbers.test(number)) {
            showToast("Mobile number should contain only numbers.");
            return;
        }

        const phoneValidation = validateMobileNumber(countryCode, number);
        if (!phoneValidation.valid) {
            showToast(phoneValidation.message);
            return;
        }

        if (hearAbout === "Other" && hearOther.trim() === "") {
            showToast("Please specify how you heard about MH Cockpit.");
            return;
        }

        if (!consent) {
            showToast("Please authorize MH Cockpit to contact you.");
            return;
        }

        try {
            const now = new Date();
            const newData = {
                Name: name,
                Email: mail,
                Country_code: countryCode,
                Mobile_Number: number,
                Qualification: qualification,
                Looking_For: lookingfor,
                State: state,
                Zip_code: district,
                Heard_About: hearAbout === "Other" ? hearOther : hearAbout,
                Message_Box: message,
                Consent: consent ? "Yes" : "No",
                Created_Date: now.toISOString().split("T")[0],
                Created_Time: now.toTimeString().split(" ")[0],
                Source_Page: "https://vels.mhcockpit.com/",
            };

            await axios.post("https://sheetdb.io/api/v1/d6aigwrmryn5s", newData);

            // Reset form
            setName("");
            setMail("");
            setCountryCode("");
            setNumber("");
            setQualification("");
            setLookingfor("");
            setState("");
            setProgramType("");
            setDistrict("");
            setHearAbout("");
            setHearOther("");
            setMessage("");
            setConsent(false);

            showToast("Form submitted successfully!", "success");
            navigate("/thank-you");
        } catch (err) {
            console.error(err);
            showToast("Submission failed.");
        }
    };

    return (
        <section
            className="w-full py-10 px-5 md:px-16 lg:px-24 bg-gradient-to-b from-orange-300 to-white"
        //   style={{
        //     backgroundImage:
        //       "url('https://images.unsplash.com/photo-1530545124313-ce5e8eae55af?q=80&w=1171&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D')",
        //     backgroundSize: "cover",
        //     backgroundPosition: "center",
        //   }}
        //   aria-label="Hero - Admissions 2026-2027"
        >
            {/* optional dark overlay for contrast */}
            {/* <div className="w-full bg-black/30 py-10 px-0 rounded-lg"> */}
            <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-10 items-center">

                {/* LEFT SIDE CONTENT */}
                <motion.div
                    initial={{ opacity: 0, y: 30 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.6, delay: 0.2 }}
                    className="flex flex-col items-start text-left space-y-4 px-4"
                >

                    <div className='flex justify-center items-center gap-10'>
                        <div className='flex justify-center items-center'>
                            <FadeInSectionDownToUp>
                                <img className='w-40' src='https://mhcockpit.com/Media/Colleges/Vels%20Landing/Converted/vels-logo.webp' alt='Vels University' />
                            </FadeInSectionDownToUp>
                        </div>
                        <div className='flex justify-center items-center'>
                            <FadeInSectionDownToUp>
                                <img className='w-40' src='https://mhcockpit.com/Media/Colleges/Vels%20Landing/Converted/accreditation.webp' alt='Vels University' />
                            </FadeInSectionDownToUp>
                        </div>
                    </div>
                    <h1 className="text-4xl lg:text-6xl font-semibold tracking-tighter">
                        2026 - 2027
                        <br />
                        <span className="font-bold bg-gradient-to-b from-[#FE8400] to-[#FF4400] text-transparent bg-clip-text pr-2">
                            Admissions
                        </span>
                        Open
                    </h1>

                    <h2 className="text-3xl lg:text-5xl tracking-tight font-semibold">
                        <span className="text-[#000074] font-bold">Vision</span> takes <br /> <span className="text-[#000074] font-bold">Flight</span> effortlessly
                    </h2>

                    <h3 className="text-3xl lg:text-5xl tracking-tight font-semibold">
                        with <span className="text-[#000074] font-extrabold">VELS.</span>
                    </h3>

                    {/* <p className="text-lg bg-gradient-to-b from-[#FE8400] to-[#FF4400] text-white px-4 py-2 rounded-full font-semibold inline-block">
                        Department of Aviation
                    </p> */}

                    <a
                        className='bg-gradient-to-b hover:bg-gradient-to-t from-[#fc8d06] to-[#ff4d00] text-white text-xl font-semibold p-3 rounded-full'
                        href='https://erp.vistas.ac.in/velsonline/applicationist/loginManager/applicantRegistration.jsp'
                        target='blank'
                    >
                        Apply Now
                    </a>

                    <div className="flex items-start gap-3 mt-3">
                        <p className="text-lg font-semibold text-[#000074]">Knowledge Partner</p>
                        <img
                            src="https://mhcockpit.com/Media/Logo/mh-cockpit-logo-black-and-grey.webp"
                            alt="MH Cockpit Logo"
                            className="w-32"
                        />
                    </div>
                </motion.div>

                {/* RIGHT SIDE FORM */}
                <motion.div
                    initial={{ opacity: 0, y: 40 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.6 }}
                    className="bg-white/95 backdrop-blur-sm rounded-2xl shadow-xl p-6 w-full"
                >
                    <FadeInSectionDownToUp>
                        <h2 className="text-2xl font-bold text-[#000074] mb-4">Get Your Brochure</h2>

                        <form className="" onSubmit={(e) => { e.preventDefault(); addData(); }}>
                            {/* Name & Mail */}
                            <div className="grid grid-cols-1 md:grid-cols-2 gap-3 py-2">
                                <div>
                                    <label className="font-semibold">Name<span className="text-red-500">*</span></label>
                                    <input
                                        className="w-full px-3 py-2 rounded-md border border-black"
                                        placeholder="Name"
                                        value={name}
                                        maxLength={50}
                                        required
                                        onChange={(e) => {
                                            const value = e.target.value;
                                            if (/^[A-Za-z\s]*$/.test(value)) {
                                                setName(value);
                                            }
                                        }}
                                    />
                                </div>
                                <div>
                                    <label className="font-semibold">Mail ID<span className="text-red-500">*</span></label>
                                    <input
                                        className="w-full px-3 py-2 rounded-md border border-black"
                                        placeholder="Email ID"
                                        value={mail}
                                        required
                                        onChange={(e) => setMail(e.target.value)}
                                    />
                                </div>
                            </div>

                            {/* ISD Code & Mobile + Program Type */}
                            <div className="flex gap-3 py-2 items-end flex-nowrap min-w-0">
                                <div className="flex-1 min-w-0">
                                    <ContactNumberField
                                        countryCode={countryCode}
                                        number={number}
                                        onCountryChange={(selectedCountry) => {
                                            setCountryCode(selectedCountry?.code || selectedCountry || "");
                                            setNumber("");
                                        }}
                                        onNumberChange={setNumber}
                                        maxLength={getPhoneMaxLength(countryCode)}
                                        required
                                    />
                                </div>

                                {/* UG / PG */}
                                <div className="w-[90px] sm:w-[100px] flex-shrink-0">
                                    <label className="font-semibold block mb-1">
                                        Program<span className="text-red-500">*</span>
                                    </label>
                                    <select
                                        className="w-full h-[42px] px-2 rounded-md border border-black"
                                        value={programType}
                                        onChange={(e) => {
                                            setProgramType(e.target.value);
                                            setQualification("");
                                            setLookingfor("");
                                        }}
                                    >
                                        <option value="" disabled>Select</option>
                                        <option value="UG">UG</option>
                                        <option value="PG">PG</option>
                                    </select>
                                </div>
                            </div>

                            {/* Qualification & Looking For */}
                            <div className="grid grid-cols-1 md:grid-cols-2 gap-3 py-2">
                                {/* QUALIFICATION */}
                                <div>
                                    <label className="font-semibold block mb-1">
                                        Qualification<span className="text-red-500">*</span>
                                    </label>

                                    <select
                                        className={`px-3 py-2 rounded-md w-full border border-black ${!programType ? "cursor-not-allowed" : ""}`}
                                        value={qualification}
                                        required
                                        disabled={!programType}
                                        onChange={(e) => {
                                            setQualification(e.target.value);
                                            setLookingfor("");
                                        }}
                                    >
                                        <option value="" disabled>Select Qualification</option>

                                        {programType === "UG" ? (
                                            Object.keys(VelsUniversityCourses).map((qualificationName) => (
                                                <option
                                                    key={qualificationName}
                                                    value={qualificationName}
                                                >
                                                    {qualificationName}
                                                </option>
                                            ))
                                        ) : (
                                            Object.keys(VelsUniversityPGCourses).map((qualificationName) => (
                                                <option
                                                    key={qualificationName}
                                                    value={qualificationName}
                                                >
                                                    {qualificationName}
                                                </option>
                                            ))
                                        )}
                                    </select>
                                </div>

                                {/* LOOKING FOR */}
                                <div>
                                    <label className="font-semibold block mb-1">
                                        Looking For<span className="text-red-500">*</span>
                                    </label>

                                    <select
                                        className="px-3 py-2 rounded-md w-full border border-black"
                                        value={lookingfor}
                                        onChange={(e) => setLookingfor(e.target.value)}
                                        disabled={!qualification}
                                        required
                                    >
                                        <option value="" disabled>Looking For</option>

                                        {programType === "UG" ? (
                                            qualification &&
                                            VelsUniversityCourses[qualification]?.map((course) => (
                                                <option
                                                    key={course}
                                                    value={course}
                                                >
                                                    {course}
                                                </option>
                                            ))
                                        ) : (
                                            qualification &&
                                            VelsUniversityPGCourses[qualification]?.map((course) => (
                                                <option
                                                    key={course}
                                                    value={course}
                                                >
                                                    {course}
                                                </option>
                                            ))
                                        )}
                                    </select>
                                </div>
                            </div>

                            {/* State & District */}
                            <LocationSelector
                                countryCode={countryCode}
                                state={state}
                                setState={setState}
                                district={district}
                                setDistrict={setDistrict}
                            />

                            {/* How did you hear */}
                            <label className="font-semibold">How did you hear about MH Cockpit?<span className="text-red-500">*</span></label>
                            <div className="py-2">
                                <select
                                    className="w-full px-3 py-2 rounded-md border border-black"
                                    value={hearAbout}
                                    onChange={(e) => setHearAbout(e.target.value)}
                                >
                                    <option value="" disabled hidden>Select</option>
                                    <option>Google / Bing / Search Engine</option>
                                    <option>Social Media (FB, Insta, etc.)</option>
                                    <option>Referred by Friends / Relatives</option>
                                    <option>Alumni (Passed Out)</option>
                                    <option>AI Recommended (ChatGPT, Gemini, etc.)</option>
                                    <option>Advertisement (online / offline)</option>
                                    <option>Event / Workshop / Expo</option>
                                    <option value="Other">Other (please specify)</option>
                                </select>

                                {hearAbout === "Other" && (
                                    <input
                                        className="w-full px-3 py-2 rounded-md mt-2 border border-black"
                                        placeholder="Please specify"
                                        value={hearOther}
                                        onChange={(e) => setHearOther(e.target.value)}
                                    />
                                )}
                            </div>

                            {/* Message */}
                            <label className="font-semibold">Message (optional)</label>
                            <textarea
                                className="w-full px-3 py-2 rounded-md h-24 border border-black"
                                placeholder="Type Your Message"
                                value={message}
                                onChange={(e) => setMessage(e.target.value)}
                            />

                            {/* Consent */}
                            <div className='py-3 flex items-start'>
                                <input type='checkbox' id='consent' className='mt-1 mr-2' checked={consent} onChange={(e) => setConsent(e.target.checked)} />
                                <label htmlFor='consent' className='text-sm text-gray-700'>
                                    I authorize <strong>MH Cockpit</strong> and its representatives to contact me with updates and notifications via Email, SMS, WhatsApp, and Call. This will override the registry on DND / NDNC.
                                </label>
                            </div>

                            <div className="text-center">
                                <button
                                    disabled={!consent}
                                    type="submit"
                                    className={`px-10 py-2 rounded-md shadow transition-all duration-300
                                    ${consent
                                            ? "bg-[#FF4400] text-white hover:bg-[#FE8400] cursor-pointer"
                                            : "bg-gray-400 cursor-not-allowed text-white"
                                    }`}
                                >
                                    Submit
                                </button>
                            </div>
                        </form>
                    </FadeInSectionDownToUp>
                </motion.div>
            </div>
            {/* </div> */}
            {toast.show && (
                <div className="fixed top-5 right-5 z-50">
                    <div
                        className={`px-6 py-3 rounded-lg shadow-2xl text-white font-semibold transition-all duration-300 ${toast.type === "success" ? "bg-green-600" : "bg-red-500"}`}
                    >
                        {toast.message}
                    </div>
                </div>
            )}
        </section>
    );
}
